//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
export { HttpMethod, AuthStrategy, ShardingStrategy } from "./src/HttpClient";
